import React from 'react';

import { MDText } from 'i18n-react';

import { InfoIcon } from '@motorway/mw-highway-code';

import { Tooltip } from 'Storybook/components/local/Tooltip/Tooltip';

import { formatDateTime } from '../DateChipSelect/DateChipSelect.helpers';

import { getThreshold } from './DateSelectionIndicator.helpers';
import LocalTexts from './DateSelectionIndicator.texts.json';

import styles from './DateSelectionIndicator.scss';

const LocalT = new MDText(LocalTexts);

export type DateSelectionIndicatorProps = {
  expiryTime?: string;
  selectedCount: number;
}

const DateSelectionIndicator = (
  {
    expiryTime,
    selectedCount,
  }: DateSelectionIndicatorProps,
) => {
  const { level, levelInfo, levelScore } = getThreshold({ selectedCount });

  const expiryTimeFormatted = expiryTime && formatDateTime({ timestamp: expiryTime, withWeekday: true });

  return <>
    <div className={styles.dateSelectionIndicator}>
      <div className={styles.indicator} data-level={level}>
        <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <rect fill="#E2E1D9" height="1.5" width="18" x="3" y="7"/>
          <rect fill="#E2E1D9" height="1.5" width="12" x="6" y="11.5"/>
          <rect fill="#E2E1D9" height="1.5" width="6" x="9" y="16"/>
        </svg>
      </div>
      <h6 className={styles.levelTitle}>{levelScore}</h6>
      <Tooltip
        className={styles.tooltip}
        maxWidth={280}
        overlay={(<>{LocalT.translate('tooltip')}</>)}
        placement="bottom"
      >
        <span className={styles.icon}><InfoIcon filled={false} size='xsmall' /></span>
      </Tooltip>
    </div>
    {levelInfo && <div className={styles.indicatorInfo}>{levelInfo}</div>}
    {expiryTimeFormatted && <p className={styles.submitBy}>{LocalT.translate('submitBy')} {expiryTimeFormatted}</p>}
  </>;
};

export default DateSelectionIndicator;
